import {IUserTicketPrize} from "../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "./abstract/in-game-ticket-prize-types";
import {InGameTicketPrizeAbstract} from "./abstract/in-game-ticket-prize.abstract";

/**
 * https://evokeplc.atlassian.net/wiki/spaces/CRMSX/pages/542710740/Bonus+Types
 * Freeplay Voucher 
 *
 * Opportunity for players to play casino on our expense.
 * Winnings become immediate bonus excluding jackpot wins
 * Player must finish the voucher in order to get the winnings
 * Fixed amount of money to specific machine/s
 * Max cap on the Free Play winnings (Player can choose whether to keep playing)
 * Can be used only in section8 games.
 * 
 * a.k.a for us "{prizeValue} freeplay voucher"
 */
export class InGameTicketFreePlayVoucherPrize extends InGameTicketPrizeAbstract {
    constructor(protected _prizeData: IUserTicketPrize, private services: IServiceFactoryExtended) {
        if (InGameTicketPrizeType.FreePlayVoucher !== _prizeData.prizeType) {
            throw new Error("Free Play Voucher cannot be given this prizeType" + _prizeData.prizeType);
        }
        super(_prizeData);
    }
    public prizeString() {
        // return this.services.translation.translate("IGC_FREE_SPINS_PRIZE_TEMPLATE", {prizeValue: this._prizeData.prizeValue});
        return `${this._prizeData.prizeValue} freeplay voucher${this._prizeData.prizeValue>1 ? 's' : ''}`;
    }
}
